<script setup lang="ts">
const props = defineProps({
  item: null,
  index: null,
  isGrid: { type: Boolean },
  parentIndex: null,
  postAllList: null
})

const emit = defineEmits(['viewHandle'])

const { t } = useI18n()
const { needMask, isVideo } = usePost()

const viewPost = ref(Local.get('viewPost') || [])
const showModal = ref(false)
useLockAppScrollWhenVisible(showModal)

const postView = (id: number = props.item.id, index = 0) => {
  if (isMobile()) {
    GlobalThis.$postViewPhoneModal.show(props.postAllList, id, index)
  } else {
    GlobalThis.$postViewModal.show(props.postAllList, id, index)
  }
}

const viewHandle = () => {
  viewPost.value = Local.get('viewPost') || []
  if (!viewPost.value.includes(props.item.id)) {
    viewPost.value.push(props.item.id)
  }
  Local.set('viewPost', viewPost.value)
  useUserStore().SET_VIEW_HANDLE(viewPost.value)
  if (isVideo(props.item) || props.isGrid) {
    emit('viewHandle', props.item.id)
  } else {
    postView(props.item.id, props.index || 0)
  }
}
defineExpose({ viewHandle })
</script>

<template>
  <div>
    <div
      v-if="needMask(item)"
      v-auth
      class="flex flex-col justify-center items-center w-full h-full absolute top-0 left-0 z-1 cursor-pointer bg-black bg-op-20"
    >
      <div class="w-10 h-8 text-white" i-fa6-solid-eye-slash />
      <div
        class="text-base text-white typeface-robotoMedium mt-3"
        :class="isGrid ? 'hidden sm:block' : ''"
      >
        {{ t('Post.SensitiveContent') }}
      </div>
      <div class="mt-3 flex items-center">
        <DfansButton
          :text="isGrid ? '' : t('Post.View')"
          class="h-9"
          type="default"
          @click="viewHandle"
        >
          <template #icon>
            <div :class="isGrid ? '' : 'mr-1.5'" i-fa6-solid-eye />
          </template>
        </DfansButton>

        <DfansButton
          type="cancel"
          :text="isGrid ? '' : t('Btn.DisableFilter')"
          class="h-9 ml-2 !text-white !bg-black !bg-op-30"
          @click="showModal = true"
        >
          <template #icon>
            <div :class="`${isGrid ? '' : 'mr-1.5'} text-white`" i-carbon:settings-view />
          </template>
        </DfansButton>
      </div>
    </div>
    <n-modal v-model:show="showModal" :mask-closable="false" transform-origin="center">
      <div class="w-11/12 md:w-105">
        <div class="modal-content sm:p-6 sm:pb-12 p-4 pb-10">
          <header class="flex justify-between items-center mb-5">
            <div class="text-lg sm:text-5.5 typeface-robotoMedium">
              {{ t('Post.SensitiveContentFilter') }}
            </div>
            <div i-carbon:close class="cursor-pointer text-6 -mr-2" @click="showModal = false" />
          </header>
          <DisableFilter />
        </div>
      </div>
    </n-modal>
  </div>
</template>
